import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-circle",
  "use": "icon-circle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-circle\"><defs><style type=\"text/css\"></style></defs><path d=\"M188.8 835.2h644.8V188.8H188.8v646.4z m32-614.4h580.8v580.8H220.8V220.8z\" p-id=\"5029\" /><path d=\"M278.4 420.8h465.6v-142.4H278.4v142.4z m16-128h433.6v110.4H294.4v-110.4zM275.2 739.2H496V472H275.2v267.2z m16-251.2H480v233.6H291.2V488zM555.2 472h188.8v16H555.2zM555.2 534.4h188.8v16H555.2zM555.2 596.8h188.8v16H555.2zM555.2 723.2h188.8v16H555.2zM555.2 660.8h188.8v16H555.2z\" p-id=\"5030\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/circle.svg
// module id = 5gjf
// module chunks = 31